import { render, staticRenderFns } from "./waterFeeTemplate.vue?vue&type=template&id=715f42f4&"
import script from "./waterFeeTemplate.vue?vue&type=script&lang=js&"
export * from "./waterFeeTemplate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports